<div class="dialog__container assistance-coverages-comparison assistance-coverages-comparison--assistance">
  <div class="dialog__header">

    <div class="dialog__close"
         [ngClass]="{
          'opacity-0': !dialogCloseVisible,
          'opacity-1': dialogCloseVisible
         }"
         (click)="close()" cdkFocusRegionstart>
      <span class="material-icons">close</span>
    </div>

    <div class="two-container">
      <div class="dialog__title">
        <span class="dialog__title--text">{{ 'ASSISTANCE_COVERAGES_COMPARISON.title_ASSISTANCE' | translate }}</span>
      </div>
    </div>
  </div>

    <div class="assistance-coverages-comparison__table">
      <div *ngFor="let config of coveragesConfig; let i = index" class="assistance-coverages-comparison__table__row">
        <div class="assistance-coverage__label">
          <div class="assistance-coverage__label__top"></div>
          <span>{{ getCoverageLabel(config) | translate }}</span>
        </div>
        <div class="assistance-coverage__values">
            <ng-container *ngFor="let variant of assistanceVariantsOrder">
                <app-assistance-coverage-value *ngIf="hasVariant(variant)"
                                               class="assistance-coverage__value"
                                               [class.assistance-coverage__value--recommended]="isVariantRecommended(variant)"
                                               [showRecommendation]="shouldShowRecommendation(variant, i)"
                                               [value]="getVariantConfig(config, variant)">
                </app-assistance-coverage-value>
            </ng-container>
        </div>
      </div>
    </div>

    <div class="assistance-coverages-comparison__pricing-row">
      <div class="assistance-coverages-comparison__pricing-row__label">
        {{ 'ASSISTANCE_COVERAGES_COMPARISON.variantPrice' | translate | uppercase }}
      </div>
      <div class="assistance-coverages-comparison__pricing-row__prices">
        <div *ngFor="let pricingItem of pricingData" class="assistance-coverages-comparison__pricing-row__price">
          <app-offer-modification-price [price]="pricingItem.price">
          </app-offer-modification-price>
          <button class="btn btn--secondary btn--small-padding" (click)="selectAssistance(pricingItem.name)">
            {{'ASSISTANCE_COVERAGES_COMPARISON.choose' | translate}}
          </button>
        </div>
      </div>
    </div>

</div>
